import { useEffect, useState } from 'react';

export default function useDebounce(valor, delayMs = 400) {
  const [debounced, setDebounced] = useState(valor);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(valor), delayMs);
    return () => clearTimeout(timer);
  }, [valor, delayMs]);

  return debounced;
}
